/**
 * Action types for the Predictions510 store.
 * @typedef {Object} ACTION_TYPES
 * @property {string} SET_TARGET_LIST - Action type for setting target list.
 * @property {string} SET_CELL_CULTURE - Action type for setting cell culture.
 * @property {string} SET_GEL_PREDICTION - Action type for setting protein prediction.
 * @property {string} SET_HELD_OBJECT - Action type for setting held object.
 * @property {string} REMOVE_CELL_CULTURE_TYPE - Action type for removing cell culture type.
 */
export const ACTION_TYPES = {
  SET_GEL_PREDICTION: "SET_GEL_PREDICTION",
  SET_HELD_OBJECT: "SET_HELD_OBJECT",
  SET_CELL_CULTURE: "SET_CELL_CULTURE",
  REMOVE_CELL_CULTURE_TYPE: "REMOVE_CELL_CULTURE_TYPE",
};

/**
 * Sets the protein gel prediction.
 *
 * @param {any} payload - The payload to set as the protein gel prediction.
 * @returns {Object} - The action object with the type and payload.
 */
export const setGelPrediction = (payload) => ({
  type: ACTION_TYPES.SET_GEL_PREDICTION,
  payload,
});

/**
 * Sets the held object.
 *
 * @param {any} payload - The payload to set as the held object.
 * @returns {Object} - The action object with the type and payload.
 */
export const setHeldObject = (payload) => ({
  type: ACTION_TYPES.SET_HELD_OBJECT,
  payload,
});

/**
 * Sets the cell culture.
 *
 * @param {any} payload - The payload to set as the cell culture.
 * @returns {Object} - The action object with the type and payload.
 */
export const setCellCulture = (payload) => ({
  type: ACTION_TYPES.SET_CELL_CULTURE,
  payload,
});

/**
 * Removes a cell culture type.
 *
 * @param {any} payload - The payload containing information about the cell culture type to be removed.
 * @returns {Object} - The action object with the type and payload.
 */
export const removeCellCultureType = (payload) => ({
  type: ACTION_TYPES.REMOVE_CELL_CULTURE_TYPE,
  payload,
});
